namespace Core {
    angular
        .module('core')
        .directive('pricingModals', (
            voucherModalService: any,
            tripService: Core.TripService,
            $route: any,
            cookieService: any
        ): ng.IDirective => {
            return {
                restrict: 'E',
                template: '<voucher-modal show="showVoucherModal" close="closeVoucherModal()"'
                    + ' voucher-info="voucherModalInfo"></voucher-modal>'
                    + '<call-to-book-modal show="showCallToBookModal" close="closeCallToBookModal()">'
                    + '</call-to-book-modal>',
                link: function ($scope) {
                    $scope.voucherModalInfo = {};
                    $scope.showCallToBookModal = false;
                    $scope.showVoucherModal = false;

                    $scope.closeVoucherModal = function () {
                        $scope.showVoucherModal = false;
                    };

                    $scope.closeCallToBookModal = function () {
                        $scope.showCallToBookModal = false;
                    };

                    const voucherInfoResponse = (data) => {
                        const showedModals = JSON.parse(sessionStorage.getItem('pricingShowedModals')
                        || '{ "callToBook": false, "vouchers": [] }');

                        $scope.voucherModalInfo = data && data.ModalForm || {};
                        $scope.showCallToBook = (data && data.CallToBookRequested || '') && !showedModals.callToBook;


                        if (!_.isEmpty($scope.voucherModalInfo)) {
                            let isShowedVoucher = false;
                            _.forEach(showedModals.vouchers, voucher => {
                                if(voucher === $scope.voucherModalInfo.VoucherCode){
                                    isShowedVoucher = true;
                                    return false;
                                }
                            });
                            if(!isShowedVoucher){
                                $scope.showVoucherModal = true;
                                $scope.showCallToBookModal = false;
                                showedModals.vouchers.unshift($scope.voucherModalInfo.VoucherCode);
                            }
                        } else if ($scope.showCallToBook) {
                            $scope.showVoucherModal = false;
                            $scope.showCallToBookModal = true;
                            showedModals.callToBook = true;
                        }

                        sessionStorage.setItem('pricingShowedModals', JSON.stringify(showedModals));
                    };

                    $scope.$on('$locationChangeSuccess', function () {
                        const paramBoardTypes = $route.current.params && $route.current.params.fbt || '';
                        const tripId: string = $route.current.params && $route.current.params.tripId || '';
                        const userId: string = $route.current.params && $route.current.params.userId || '';
                        const estabId: number = Number($route.current.params && $route.current.params.estabId || 0);
                        const sourceId: number = Number(cookieService.get('visitSource') || 0);
                        const boardType: number[] = paramBoardTypes.length > 0 ?
                            paramBoardTypes.split(',').map(item => {
                                const board = item && parseInt(item, 10) || null;
                                if (board) {
                                    return board;
                                }
                            }) : [];

                        if (tripId) {
                            tripService.getTrip(tripId).then(trip => {
                                const adults = trip.HotelsRequest.Rooms.map(x => x.Adults)
                                                                        .reduce((a, b) => a + b);
                                const children = trip.HotelsRequest.Rooms.map(x => x.ChildAges.length)
                                                                        .reduce((a, b) => a + b);

                                const selections = JSON.parse(localStorage.getItem('flightsSelections') || '{}');
                                const inboundSegmentDetails = selections.InboundSegmentDetails
                                                                    && selections.InboundSegmentDetails[0] || {};
                                const outboundSegmentDetails = selections.OutboundSegmentDetails
                                                                    && selections.OutboundSegmentDetails[0] || {};

                                const options = {
                                    DestinationAirport: inboundSegmentDetails.DepartureAirport || null,
                                    OriginalAirport: outboundSegmentDetails.DepartureAirport || null,
                                    Adults: adults,
                                    Children: children,
                                    CheckInDate: trip.HotelsRequest.CheckInDate,
                                    CheckOutDate: trip.HotelsRequest.CheckOutDate,
                                    IsPackage: trip.PackageId ? true : false,
                                    IsFlightPlus: trip.HotelsRequest.IsFlightPlus || false,
                                    Cabin: outboundSegmentDetails.Cabin || 0,
                                    UserId: userId,
                                    EstabId: estabId,
                                    VisitSourceId: sourceId,
                                    BoardType: boardType,
                                    DepartureDate: trip.FlightsRequest && trip.FlightsRequest.DepartureDate || '',
                                    RoomsCount: trip.HotelsRequest.Rooms.length,
                                    Carrier: outboundSegmentDetails.CarrierCode
                                };

                                voucherModalService.getVoucherInfo(options).then(voucherInfoResponse);
                            });
                        } else {
                            voucherModalService.getVoucherInfo().then(voucherInfoResponse);
                        }
                    });
                }
            };
        });
}
